function fetchConfig(type = "json") {
  var contentType = "application/" + type;
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: contentType,
    },
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button"),
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    ),
    summary.nextElementSibling.getAttribute("id") &&
    summary.setAttribute("aria-controls", summary.nextElementSibling.id),
    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    }),
    !summary.closest("header-drawer, menu-drawer") &&
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container),
    first = elements[0],
    last = elements[elements.length - 1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (event) => {
      (event.target !== container &&
        event.target !== last &&
        event.target !== first) ||
        document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (event) {
      event.code.toUpperCase() === "TAB" &&
        (event.target === last &&
          !event.shiftKey &&
          (event.preventDefault(), first.focus()),
          (event.target === container || event.target === first) &&
          event.shiftKey &&
          (event.preventDefault(), last.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    elementToFocus.focus(),
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value &&
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null,
    mouseClick = null;
  window.addEventListener("keydown", (event) => {
    navKeys.includes(event.code.toUpperCase()) && (mouseClick = !1);
  }),
    window.addEventListener("mousedown", (event) => {
      mouseClick = !0;
    }),
    window.addEventListener(
      "focus",
      () => {
        currentFocusedElement &&
          currentFocusedElement.classList.remove("focused"),
          !mouseClick &&
          ((currentFocusedElement = document.activeElement),
            currentFocusedElement.classList.add("focused"));
      },
      !0
    );
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((video) => video.pause()),
    document.querySelectorAll("product-model").forEach((model) => {
      model.modelViewerUI && model.modelViewerUI.pause();
    });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    elementToFocus && elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;
  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open"),
    summaryElement.setAttribute("aria-expanded", !1),
    summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", {
        bubbles: !0,
      })),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((button) =>
        button.addEventListener("click", this.onButtonClick.bind(this))
      );
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(
        PUB_SUB_EVENTS.quantityUpdate,
        this.validateQtyRules.bind(this)
      ));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown(),
      previousValue !== this.input.value &&
      this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      this.querySelector(".quantity__button[name='minus']").classList.toggle(
        "disabled",
        value <= min
      );
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      this.querySelector(".quantity__button[name='plus']").classList.toggle(
        "disabled",
        value >= max
      );
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t), (t = setTimeout(() => fn.apply(this, args), wait));
  };
}
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (!(now - lastCall < delay)) return (lastCall = now), fn(...args);
  };
}
typeof window.Shopify > "u" && (window.Shopify = {}),
  (Shopify.bind = function (fn, scope) {
    return function () {
      return fn.apply(scope, arguments);
    };
  }),
  (Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML)
        return (selector.selectedIndex = i), i;
    }
  }),
  (Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
      ? target.addEventListener(eventName, callback, !1)
      : target.attachEvent("on" + eventName, callback);
  }),
  (Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options.method || "post",
      params = options.parameters || {},
      form = document.createElement("form");
    form.setAttribute("method", method), form.setAttribute("action", path);
    for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden"),
        hiddenField.setAttribute("name", key),
        hiddenField.setAttribute("value", params[key]),
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form),
      form.submit(),
      document.body.removeChild(form);
  }),
  (Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
  ) {
    (this.countryEl = document.getElementById(country_domid)),
      (this.provinceEl = document.getElementById(province_domid)),
      (this.provinceContainer = document.getElementById(
        options.hideElement || province_domid
      )),
      Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
      ),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var value = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, value), this.countryHandler();
    },
    initProvince: function () {
      var value = this.provinceEl.getAttribute("data-default");
      value &&
        this.provinceEl.options.length > 0 &&
        Shopify.setSelectorByValue(this.provinceEl, value);
    },
    countryHandler: function (e) {
      var opt = this.countryEl.options[this.countryEl.selectedIndex],
        raw = opt.getAttribute("data-provinces"),
        provinces = JSON.parse(raw);
      if (
        (this.clearOptions(this.provinceEl), provinces && provinces.length == 0)
      )
        this.provinceContainer.style.display = "none";
      else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement("option");
          (opt.value = provinces[i][0]),
            (opt.innerHTML = provinces[i][1]),
            this.provinceEl.appendChild(opt);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (selector) {
      for (; selector.firstChild;) selector.removeChild(selector.firstChild);
    },
    setOptions: function (selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement("option");
        (opt.value = values[i]),
          (opt.innerHTML = values[i]),
          selector.appendChild(opt);
      }
    },
  });
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector("details")),
      this.addEventListener("keyup", this.onKeyUp.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll("button:not(.localization-selector)").forEach(
        (button) =>
          button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    openDetailsElement &&
      (openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
        : this.closeSubmenu(openDetailsElement));
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget,
      detailsElement = summaryElement.parentNode,
      parentMenuElement = detailsElement.closest(".has-submenu"),
      isOpen = detailsElement.hasAttribute("open"),
      reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      ),
        summaryElement.nextElementSibling.removeEventListener(
          "transitionend",
          addTrapFocus
        );
    }
    detailsElement === this.mainDetailsToggle
      ? (isOpen && event.preventDefault(),
        isOpen
          ? this.closeMenuDrawer(event, summaryElement)
          : this.openMenuDrawer(summaryElement),
        window.matchMedia("(max-width: 990px)") &&
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        ))
      : setTimeout(() => {
        detailsElement.classList.add("menu-opening"),
          summaryElement.setAttribute("aria-expanded", !0),
          parentMenuElement &&
          parentMenuElement.classList.add("submenu-open"),
          !reducedMotion || reducedMotion.matches
            ? addTrapFocus()
            : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    }),
      summaryElement.setAttribute("aria-expanded", !0),
      trapFocus(this.mainDetailsToggle, summaryElement),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus = !1) {
    event !== void 0 &&
      (this.mainDetailsToggle.classList.remove("menu-opening"),
        this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
          details.removeAttribute("open"),
            details.classList.remove("menu-opening");
        }),
        this.mainDetailsToggle
          .querySelectorAll(".submenu-open")
          .forEach((submenu) => {
            submenu.classList.remove("submenu-open");
          }),
        document.body.classList.remove(
          `overflow-hidden-${this.dataset.breakpoint}`
        ),
        removeTrapFocus(elementToFocus),
        this.closeAnimation(this.mainDetailsToggle),
        event instanceof KeyboardEvent &&
        elementToFocus &&
        elementToFocus.setAttribute("aria-expanded", !1));
  }
  onFocusOut() {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open"),
      detailsElement.classList.remove("menu-opening"),
      detailsElement.querySelector("summary").setAttribute("aria-expanded", !1),
      removeTrapFocus(detailsElement.querySelector("summary")),
      this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      animationStart === void 0 && (animationStart = time),
        time - animationStart < 400
          ? window.requestAnimationFrame(handleAnimation)
          : (detailsElement.removeAttribute("open"),
            detailsElement.closest("details[open]") &&
            trapFocus(
              detailsElement.closest("details[open]"),
              detailsElement.querySelector("summary")
            ));
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super(), (this.header = document.querySelector(".section-header"));
  }
  openMenuDrawer(summaryElement) {
    (this.header = this.header || document.querySelector(".section-header")),
      (this.borderOffset =
        this.borderOffset ||
          this.closest(".header-wrapper").classList.contains(
            "header-wrapper--border-bottom"
          )
          ? 1
          : 0),
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      this.header.classList.add("menu-open"),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      }),
      summaryElement.setAttribute("aria-expanded", !0),
      window.addEventListener("resize", this.onResize),
      trapFocus(this.mainDetailsToggle, summaryElement),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus) {
    elementToFocus &&
      (super.closeMenuDrawer(event, elementToFocus),
        this.header.classList.remove("menu-open"),
        window.removeEventListener("resize", this.onResize));
  }
  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      ),
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
  };
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super(),
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        "click",
        this.hide.bind(this, !1)
      ),
      this.addEventListener("keyup", (event) => {
        event.code.toUpperCase() === "ESCAPE" && this.hide();
      }),
      this.classList.contains("media-modal")
        ? this.addEventListener("pointerup", (event) => {
          event.pointerType === "mouse" &&
            !event.target.closest("deferred-media, product-model") &&
            this.hide();
        })
        : this.addEventListener("click", (event) => {
          event.target === this && this.hide();
        });
  }
  connectedCallback() {
    this.moved || ((this.moved = !0), document.body.appendChild(this));
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden"),
      this.setAttribute("open", ""),
      popup && popup.loadContent(),
      trapFocus(this, this.querySelector('[role="dialog"]')),
      window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove("overflow-hidden"),
      document.body.dispatchEvent(new CustomEvent("modalClosed")),
      this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector("button");
    button &&
      button.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        modal && modal.show(button);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    poster && poster.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(focus = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      focus && deferredElement.focus(),
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay") &&
        deferredElement.play();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
        (this.slider = this.querySelector('[id^="Slider-"]')),
        (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
        (this.enableSliderLooping = !1),
        (this.currentPageElement = this.querySelector(
          ".slider-counter--current"
        )),
        (this.pageTotalElement = this.querySelector(".slider-counter--total")),
        (this.prevButton = this.querySelector('button[name="previous"]')),
        (this.nextButton = this.querySelector('button[name="next"]')),
        !this.slider || !this.nextButton)
    )
      return;
    this.initPages(),
      new ResizeObserver((entries) => this.initPages()).observe(this.slider),
      this.slider.addEventListener("scroll", this.update.bind(this)),
      this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
      this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }
  initPages() {
    (this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    )),
      !(this.sliderItemsToShow.length < 2) &&
      ((this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft -
        this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
          this.sliderItemOffset
        )),
        (this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.update());
  }
  resetPages() {
    (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      this.initPages();
  }
  update() {
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    (this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
      this.pageTotalElement &&
      ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != previousPage &&
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      ),
      !this.enableSliderLooping &&
      (this.isSlideVisible(this.sliderItemsToShow[0]) &&
        this.slider.scrollLeft === 0
        ? this.prevButton.setAttribute("disabled", "disabled")
        : this.prevButton.removeAttribute("disabled"),
        this.isSlideVisible(
          this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        )
          ? this.nextButton.setAttribute("disabled", "disabled")
          : this.nextButton.removeAttribute("disabled"));
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    (this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset),
      this.setSlidePosition(this.slideScrollPosition);
  }
  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}
customElements.define("slider-component", SliderComponent);
class SlideshowComponent extends SliderComponent {
  constructor() {
    super(),
      (this.sliderControlWrapper = this.querySelector(".slider-buttons")),
      (this.enableSliderLooping = !0),
      this.sliderControlWrapper &&
      ((this.sliderFirstItemNode =
        this.slider.querySelector(".slideshow__slide")),
        this.sliderItemsToShow.length > 0 && (this.currentPage = 1),
        (this.announcementBarSlider = this.querySelector(
          ".announcement-bar-slider"
        )),
        (this.announcerBarAnimationDelay = this.announcementBarSlider
          ? 250
          : 0),
        (this.sliderControlLinksArray = Array.from(
          this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
        )),
        this.sliderControlLinksArray.forEach((link) =>
          link.addEventListener("click", this.linkToSlide.bind(this))
        ),
        this.slider.addEventListener(
          "scroll",
          this.setSlideVisibility.bind(this)
        ),
        this.setSlideVisibility(),
        this.announcementBarSlider &&
        ((this.announcementBarArrowButtonWasClicked = !1),
          (this.reducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
          )),
          this.reducedMotion.addEventListener("change", () => {
            this.slider.getAttribute("data-autoplay") === "true" &&
              this.setAutoPlay();
          }),
          [this.prevButton, this.nextButton].forEach((button) => {
            button.addEventListener(
              "click",
              () => {
                this.announcementBarArrowButtonWasClicked = !0;
              },
              {
                once: !0,
              }
            );
          })),
        this.slider.getAttribute("data-autoplay") === "true" &&
        this.setAutoPlay());
  }
  setAutoPlay() {
    (this.autoplaySpeed = this.slider.dataset.speed * 1e3),
      this.addEventListener("mouseover", this.focusInHandling.bind(this)),
      this.addEventListener("mouseleave", this.focusOutHandling.bind(this)),
      this.addEventListener("focusin", this.focusInHandling.bind(this)),
      this.addEventListener("focusout", this.focusOutHandling.bind(this)),
      this.querySelector(".slideshow__autoplay")
        ? ((this.sliderAutoplayButton = this.querySelector(
          ".slideshow__autoplay"
        )),
          this.sliderAutoplayButton.addEventListener(
            "click",
            this.autoPlayToggle.bind(this)
          ),
          (this.autoplayButtonIsSetToPlay = !0),
          this.play())
        : this.reducedMotion.matches ||
          this.announcementBarArrowButtonWasClicked
          ? this.pause()
          : this.play();
  }
  onButtonClick(event) {
    super.onButtonClick(event), (this.wasClicked = !0);
    const isFirstSlide = this.currentPage === 1,
      isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }
    isFirstSlide && event.currentTarget.name === "previous"
      ? (this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length)
      : isLastSlide &&
      event.currentTarget.name === "next" &&
      (this.slideScrollPosition = 0),
      this.setSlidePosition(this.slideScrollPosition),
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }
  setSlidePosition(position) {
    this.setPositionTimeout && clearTimeout(this.setPositionTimeout),
      (this.setPositionTimeout = setTimeout(() => {
        this.slider.scrollTo({
          left: position,
        });
      }, this.announcerBarAnimationDelay));
  }
  update() {
    super.update(),
      (this.sliderControlButtons = this.querySelectorAll(
        ".slider-counter__link"
      )),
      this.prevButton.removeAttribute("disabled"),
      this.sliderControlButtons.length &&
      (this.sliderControlButtons.forEach((link) => {
        link.classList.remove("slider-counter__link--active"),
          link.removeAttribute("aria-current");
      }),
        this.sliderControlButtons[this.currentPage - 1].classList.add(
          "slider-counter__link--active"
        ),
        this.sliderControlButtons[this.currentPage - 1].setAttribute(
          "aria-current",
          !0
        ));
  }
  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay),
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play(),
      (this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay);
  }
  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else
      !this.reducedMotion.matches &&
        !this.announcementBarArrowButtonWasClicked &&
        this.play();
  }
  focusInHandling(event) {
    this.sliderAutoplayButton
      ? (event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target)) &&
        this.autoplayButtonIsSetToPlay
        ? this.play()
        : this.autoplayButtonIsSetToPlay && this.pause()
      : this.announcementBarSlider.contains(event.target) && this.pause();
  }
  play() {
    this.slider.setAttribute("aria-live", "off"),
      clearInterval(this.autoplay),
      (this.autoplay = setInterval(
        this.autoRotateSlides.bind(this),
        this.autoplaySpeed
      ));
  }
  pause() {
    this.slider.setAttribute("aria-live", "polite"),
      clearInterval(this.autoplay);
  }
  togglePlayButtonState(pauseAutoplay) {
    pauseAutoplay
      ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.playSlideshow
        ))
      : (this.sliderAutoplayButton.classList.remove(
        "slideshow__autoplay--paused"
      ),
        this.sliderAutoplayButton.setAttribute(
          "aria-label",
          window.accessibilityStrings.pauseSlideshow
        ));
  }
  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;
    this.setSlidePosition(slideScrollPosition),
      this.applyAnimationToAnnouncementBar();
  }
  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      index === this.currentPage - 1
        ? (linkElements.length &&
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          }),
          item.setAttribute("aria-hidden", "false"),
          item.removeAttribute("tabindex"))
        : (linkElements.length &&
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          }),
          item.setAttribute("aria-hidden", "true"),
          item.setAttribute("tabindex", "-1"));
    }),
      (this.wasClicked = !1);
  }
  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;
    const itemsCount = this.sliderItems.length,
      increment = button === "next" ? 1 : -1,
      currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;
    const nextSlide = this.sliderItems[nextIndex],
      currentSlide = this.sliderItems[currentIndex],
      animationClassIn = "announcement-bar-slider--fade-in",
      animationClassOut = "announcement-bar-slider--fade-out",
      isFirstSlide = currentIndex === 0,
      isLastSlide = currentIndex === itemsCount - 1,
      direction =
        (button === "next" && !isLastSlide) ||
          (button === "previous" && isFirstSlide)
          ? "next"
          : "previous";
    currentSlide.classList.add(`${animationClassOut}-${direction}`),
      nextSlide.classList.add(`${animationClassIn}-${direction}`),
      setTimeout(() => {
        currentSlide.classList.remove(`${animationClassOut}-${direction}`),
          nextSlide.classList.remove(`${animationClassIn}-${direction}`);
      }, this.announcerBarAnimationDelay * 2);
  }
  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define("slideshow-component", SlideshowComponent);
let selectedOptions = [];
class VariantSelects extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("change", this.onVariantChange),
      this.addEventListener("change", this.rebuildOptions),
      this.rebuildOptions();
  }
  rebuildOptions() {
    const pickerType = document.querySelector("variant-radios")
      ? "radios"
      : "selects",
      variantSelects =
        pickerType == "radios"
          ? document.querySelector("variant-radios")
          : document.querySelector("variant-selects");
    if (!variantSelects) return;
    const fieldsets =
      pickerType == "radios"
        ? Array.from(variantSelects.querySelectorAll("fieldset"))
        : Array.from(
          variantSelects.querySelectorAll(".product-form__input--dropdown")
        );
    selectedOptions = fieldsets.map((fieldset) =>
      pickerType == "radios"
        ? Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value
        : Array.from(
          fieldset.querySelectorAll("select"),
          (select) => select.value
        )
    );
    for (
      let optionLevel = 1, n = fieldsets.length;
      optionLevel < n;
      optionLevel++
    )
      (pickerType == "radios"
        ? fieldsets[optionLevel].querySelectorAll("input")
        : fieldsets[optionLevel].querySelectorAll("option")
      ).forEach((input) => {
        if (
          ((input.disabled = !this.validCombo(input.value, optionLevel)),
            pickerType == "radios")
        ) {
          const label = fieldsets[optionLevel].querySelector(
            `label[for="${input.id}"]`
          );
          (label.style.display = input.disabled ? "none" : ""),
            (input.hidden = !this.validCombo(input.value, optionLevel));
        }
      });
    for (
      let optionLevel = 1, fieldsetsLength = fieldsets.length, change = !1;
      optionLevel < fieldsetsLength && !change;
      optionLevel++
    ) {
      if (pickerType == "radios") {
        if (
          fieldsets[optionLevel].querySelector("input:checked").disabled ===
          !0 &&
          fieldsets[optionLevel].querySelector("input:not(:disabled)")
        ) {
          const inputHidden = fieldsets[optionLevel].querySelector(
            "input[checked][disabled]"
          );
          inputHidden && inputHidden.removeAttribute("checked");
          const input = fieldsets[optionLevel].querySelector(
            "input:not(:disabled)"
          );
          input.checked = !0;
          var evt = document.createEvent("HTMLEvents");
          evt.initEvent("change", !1, !0),
            input.dispatchEvent(evt),
            (change = input);
        }
      } else
        fieldsets[optionLevel].querySelector("option:checked").disabled ===
          !0 &&
          (change = fieldsets[optionLevel].querySelector(
            "option:not(:disabled)"
          ).selected =
            "selected");
      change &&
        variantSelects.dispatchEvent(
          new Event("change", {
            bubbles: !0,
          })
        );
    }
  }
  validCombo(inputValue, optionLevel) {
    const variantSelects =
      (document.querySelector("variant-radios") ? "radios" : "selects") ==
        "radios"
        ? document.querySelector("variant-radios")
        : document.querySelector("variant-selects"),
      productJson = JSON.parse(
        variantSelects.querySelector('[type="application/json"]').textContent
      ),
      typeProduct = document.querySelector("#product_type").textContent,
      styles = ["Classic Tee", "Sweater", "Pullover Hoodie"],
      country = getCookieByProduct("code_country"),
      colorSand = "Sand",
      colorFilter = ["Sport Grey", "White", "Black"],
      sizeFilter = ["4XL", "5XL"],
      sizeCanvas = ['24" x 36"', '36" x 24"'],
      typeCanvas = "Canvas",
      sizePoster = ['11"x14"', '14"x11"', '8"x12"', '12"x8"'],
      typePoster = "Poster",
      sizeCard = ['5" x 7"', '7" x 5"'],
      pack = "1 Card";
    if (country == "US" || typeProduct == "Embroidered Shirt") return !0;
    for (let i = 0; i < productJson.length; i++)
      if (optionLevel == 1) {
        if (
          colorSand == inputValue ||
          (typeCanvas == selectedOptions[0] &&
            sizeCanvas.includes(inputValue.replace(/\s/g, ""))) ||
          (typePoster == selectedOptions[0] &&
            sizePoster.includes(inputValue.replace(/\s/g, ""))) ||
          (sizeCard.includes(selectedOptions[0]) && pack == inputValue)
        )
          return !1;
      } else if (
        optionLevel == 2 &&
        styles.includes(selectedOptions[0]) &&
        !colorFilter.includes(selectedOptions[1]) &&
        sizeFilter.includes(inputValue)
      )
        return !1;
    return !0;
  }
  onVariantChange() {
    if (
      (this.updateOptions(),
        this.updateMasterId(),
        this.toggleAddButton(!0, "", !1),
        this.updatePickupAvailability(),
        this.removeErrorMessage(),
        this.updateVariantStatuses(),
        this.currentVariant
          ? (this.updateMedia(),
            this.updateURL(),
            this.updateVariantInput(),
            this.renderProductInfo(),
            this.updateShareUrl())
          : (this.toggleAddButton(!0, "", !0), this.setUnavailable()),
        document.querySelector('#product_type[data-type="Shirt"]') &&
        showDateCutOff)
    ) {
      const codeCountry = getCookieByProduct("code_country") || "US";
      loadDateCutOff(codeCountry);
    }
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(!1)
    );
    var formatCurrency = $("body").data("money-format");
    if (!this.currentVariant) {
      if (
        !this.currentVariant &&
        this.options.length == 3 &&
        ((this.currentVariant = this.getVariantData().find(
          (variant) =>
            variant.options[0] === this.options[0] &&
            variant.options[1] === this.options[1]
        )),
          this.currentVariant ||
          (this.currentVariant = this.getVariantData().find(
            (variant) => variant.options[0] === this.options[0]
          )),
          this.currentVariant)
      ) {
        const option2 = document.querySelector(
          `input[value='${this.currentVariant.option2}']`
        );
        option2 && (option2.checked = !0);
      }
      this.currentVariant ||
        (this.currentVariant = this.getVariantData().find(
          (variant) => variant.options[0] === this.options[0]
        )),
        this.options.length == 3 &&
        this.currentVariant &&
        (document.querySelector(
          `input[value='${this.currentVariant.option3}']`
        ).checked = !0),
        this.options.length == 2 &&
        ((document.querySelector(
          `input[value="${this.currentVariant.option1}"]`
        ).checked = !0),
          (document.querySelector(
            `input[value='${this.currentVariant.option2}']`
          ).checked = !0)),
        (this.options = this.updateOptions());
    }
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    document
      .querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`)
      .forEach((mediaGallery) => {
        if (mediaGallery.setActiveMedia)
          return mediaGallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            !0
          );
      });
    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }
  updateURL() {
    !this.currentVariant ||
      this.dataset.updateUrl === "false" ||
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    !shareButton ||
      !shareButton.updateUrl ||
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
  }
  updateVariantInput() {
    document
      .querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      )
      .forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        (input.value = this.currentVariant.id),
          input.dispatchEvent(
            new Event("change", {
              bubbles: !0,
            })
          );
      });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    ),
      inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ],
        previousOptionSelected =
          inputWrappers[index - 1].querySelector(":checked").value,
        availableOptionInputsValue = selectedOptionOneVariants
          .filter(
            (variant) =>
              variant.available &&
              variant[`option${index}`] === previousOptionSelected
          )
          .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      listOfAvailableOptions.includes(input.getAttribute("value"))
        ? (input.innerText = input.getAttribute("value"))
        : (input.innerText =
          window.variantStrings.unavailable_with_option.replace(
            "[value]",
            input.getAttribute("value")
          ));
    });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    pickUpAvailability &&
      (this.currentVariant &&
        this.currentVariant.available &&
        pickUpAvailability.fetchAvailability
        ? pickUpAvailability.fetchAvailability(this.currentVariant.id)
        : (pickUpAvailability.removeAttribute("available"),
          (pickUpAvailability.innerHTML = "")));
  }
  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;
    const productForm = section.querySelector("product-form");
    productForm &&
      productForm.handleErrorMessage &&
      productForm.handleErrorMessage();
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id,
      sectionId = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, "text/html"),
          destination = document.getElementById(
            `price-${this.dataset.section}`
          ),
          source = html.getElementById(
            `price-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          ),
          skuSource = html.getElementById(
            `Sku-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          ),
          skuDestination = document.getElementById(
            `Sku-${this.dataset.section}`
          ),
          inventorySource = html.getElementById(
            `Inventory-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          ),
          inventoryDestination = document.getElementById(
            `Inventory-${this.dataset.section}`
          ),
          volumePricingSource = html.getElementById(
            `Volume-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          ),
          pricePerItemDestination = document.getElementById(
            `Price-Per-Item-${this.dataset.section}`
          ),
          pricePerItemSource = html.getElementById(
            `Price-Per-Item-${this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
            }`
          ),
          volumePricingDestination = document.getElementById(
            `Volume-${this.dataset.section}`
          ),
          qtyRules = document.getElementById(
            `Quantity-Rules-${this.dataset.section}`
          ),
          volumeNote = document.getElementById(
            `Volume-Note-${this.dataset.section}`
          );
        volumeNote && volumeNote.classList.remove("hidden"),
          volumePricingDestination &&
          volumePricingDestination.classList.remove("hidden"),
          qtyRules && qtyRules.classList.remove("hidden"),
          source && destination && (destination.innerHTML = source.innerHTML),
          inventorySource &&
          inventoryDestination &&
          (inventoryDestination.innerHTML = inventorySource.innerHTML),
          skuSource &&
          skuDestination &&
          ((skuDestination.innerHTML = skuSource.innerHTML),
            skuDestination.classList.toggle(
              "hidden",
              skuSource.classList.contains("hidden")
            )),
          volumePricingSource &&
          volumePricingDestination &&
          (volumePricingDestination.innerHTML =
            volumePricingSource.innerHTML),
          pricePerItemSource &&
          pricePerItemDestination &&
          ((pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML),
            pricePerItemDestination.classList.toggle(
              "hidden",
              pricePerItemSource.classList.contains("hidden")
            ));
        const price = document.getElementById(`price-${this.dataset.section}`);
        price && price.classList.remove("hidden"),
          inventoryDestination &&
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === ""
          );
        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : !0,
          window.variantStrings.soldOut
        );
        const currency = getCookieByProduct("currency");
        Currency &&
          currency &&
          Currency.convertAll(
            "USD",
            currency,
            ".money",
            "money_with_currency_format"
          ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant,
            },
          });
      });
  }
  toggleAddButton(disable = !0, text, modifyClass = !0) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]'),
      addButtonText = productForm.querySelector('[name="add"] > span');
    addButton &&
      (disable
        ? (addButton.setAttribute("disabled", "disabled"),
          text && (addButtonText.textContent = text))
        : (addButton.removeAttribute("disabled"),
          (addButtonText.textContent = window.variantStrings.addToCart)));
  }
  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    ),
      addButton = button.querySelector('[name="add"]'),
      addButtonText = button.querySelector('[name="add"] > span'),
      price = document.getElementById(`price-${this.dataset.section}`),
      inventory = document.getElementById(`Inventory-${this.dataset.section}`),
      sku = document.getElementById(`Sku-${this.dataset.section}`),
      pricePerItem = document.getElementById(
        `Price-Per-Item-${this.dataset.section}`
      ),
      volumeNote = document.getElementById(
        `Volume-Note-${this.dataset.section}`
      ),
      volumeTable = document.getElementById(`Volume-${this.dataset.section}`),
      qtyRules = document.getElementById(
        `Quantity-Rules-${this.dataset.section}`
      );
    addButton &&
      ((addButtonText.textContent = window.variantStrings.unavailable),
        price && price.classList.add("hidden"),
        inventory && inventory.classList.add("hidden"),
        sku && sku.classList.add("hidden"),
        pricePerItem && pricePerItem.classList.add("hidden"),
        volumeNote && volumeNote.classList.add("hidden"),
        volumeTable && volumeTable.classList.add("hidden"),
        qtyRules && qtyRules.classList.add("hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"][data-variants]')
            .textContent
        )),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      listOfAvailableOptions.includes(input.getAttribute("value"))
        ? input.classList.remove("disabled")
        : input.classList.add("disabled");
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map(
      (fieldset) =>
        Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value
    );
  }
}
customElements.define("variant-radios", VariantRadios);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      entries[0].isIntersecting &&
        (observer.unobserve(this),
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector(
                "product-recommendations"
              );
              recommendations &&
                recommendations.innerHTML.trim().length &&
                (this.innerHTML = recommendations.innerHTML),
                !this.querySelector("slideshow-component") &&
                this.classList.contains("complementary-products") &&
                this.remove(),
                html.querySelector(".grid__item") &&
                this.classList.add("product-recommendations--loaded");
            })
            .catch((e) => {
              console.error(e);
            }));
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);
class Reviews extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const reviewsSection = document.querySelector("reviews-component");
    const closeButton = document.querySelector(".popup-close");
    const openPopup = (
      image,
      name,
      content,
      created,
      proImg,
      proTitle,
      proUrl
    ) => {
      document.getElementById("popup").style.display = "flex";
      document.querySelector(
        ".popup-image"
      ).style.backgroundImage = `url(${image})`;
      document.querySelector(
        ".popup-content h3"
      ).innerHTML = `${name}<span class="verified"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.6304 8.8101C5.28785 5.84454 8.22489 3.97344 11.1904 4.63089C11.5948 4.72054 11.9953 4.46539 12.085 4.061C12.1747 3.6566 11.9195 3.2561 11.5151 3.16645C7.74075 2.32969 4.00271 4.71109 3.16596 8.48544C2.32921 12.2598 4.7106 15.9978 8.48495 16.8346C12.2593 17.6713 15.9973 15.29 16.8341 11.5156C16.9238 11.1112 16.6686 10.7107 16.2642 10.621C15.8598 10.5314 15.4593 10.7865 15.3697 11.1909C14.7122 14.1565 11.7752 16.0276 8.80961 15.3701C5.84405 14.7127 3.97295 11.7757 4.6304 8.8101Z" fill="#388E3C"></path><path d="M16.0304 6.78033C16.3233 6.48744 16.3233 6.01257 16.0304 5.71967C15.7375 5.42678 15.2626 5.42678 14.9697 5.71967L10 10.6893L7.78037 8.46967C7.48747 8.17678 7.0126 8.17678 6.71971 8.46967C6.42681 8.76257 6.42681 9.23744 6.71971 9.53033L9.46971 12.2803C9.7626 12.5732 10.2375 12.5732 10.5304 12.2803L16.0304 6.78033Z" fill="#388E3C"></path></svg></span>`;
      document.querySelector(".popup-content .review-time").innerText = created;
      document.querySelector(".popup-content .review-content").innerText =
        content;
      var productHTML = "";
      if (proImg != "") {
        productHTML += `<img class="product-review-image" src="${proImg}">`;
      }
      productHTML += `<div class="product-title">${proTitle}</div>`;
      document.querySelector(".popup-content .product-reviewed").innerHTML =
        productHTML;
      document
        .querySelector(".popup-content .product-reviewed")
        .setAttribute("href", proUrl);
    };

    // Close popup
    const closePopup = () => {
      document.getElementById("popup").style.display = "none";
    };
    // reviewsSection.querySelectorAll(".review-card").forEach((review) => {
    //   review.addEventListener("click", (e) => {
    //     if (window.innerWidth <= 767) {
    //       var image = review.getAttribute("data-image");
    //       var name = review.getAttribute("data-name");
    //       var content = review.getAttribute("data-content");
    //       var created = review.getAttribute("data-created");
    //       var proImg = review.getAttribute("data-proimg");
    //       var proTitle = review.getAttribute("data-protitle");
    //       var proUrl = review.getAttribute("data-prourl");
    //       openPopup(image, name, content, created, proImg, proTitle, proUrl);
    //     }
    //   });
    // });
    // closeButton.addEventListener("click", closePopup);
  }
}
customElements.define("reviews-component", Reviews);
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const recentlySection = document.querySelector("recently-viewed");
    var recently = JSON.parse(localStorage.getItem("recently-viewed"));
    if (recently.length > 0) {
      var query = "";
      recently.forEach((id, idx) => {
        query += idx == 0 ? `id:${id}` : ` OR id:${id}`;
      });
      fetch(window.Shopify.routes.root + "search?q=" + query)
        .then((response) => response.text())
        .then((htmlString) => {
          const parser = new DOMParser();
          const doc3 = parser.parseFromString(htmlString, "text/html");
          var related_products = doc3.querySelectorAll(
            ".product-grid .grid__item"
          );
          for (let i = 0; i < parseInt(this.dataset.limit); i++) {
            if (related_products[i] != undefined) {
              related_products.forEach((ele) => {
                if (ele.getAttribute("product-id") == recently[i]) {
                  recentlySection
                    .querySelector(".product-grid")
                    .appendChild(ele);
                }
              });
            }
          }
        });
    } else {
      recentlySection.remove();
    }
  }
}
customElements.define("recently-viewed", RecentlyViewed);
class PromotionBox extends HTMLElement{
  constructor(){
    super();
    this.copyButton = this.querySelector('.copy-discount');
    this.toast = this.querySelector('#toast');
    this.hoursEl = this.querySelector('#h');
    this.minusEl = this.querySelector('#m');
    this.secondsEl = this.querySelector('#s');
    this.countHours = this.dataset.hours;
  }
  connectedCallback() {
    this.copyButton.addEventListener('click',this.copy.bind(this));
    this.updateCountdown();
    setInterval(this.updateCountdown.bind(this), 1000);
  }
  copy(){
    this.toast.classList.add('show');
    setTimeout(() => {
      this.toast.classList.remove('show');
    },3000)
  }
  updateCountdown() {
        const now = new Date();

        // Tạo thời điểm 16h ngày mai
        const target = new Date();
        target.setDate(now.getDate() + 1);
        target.setHours(this.countHours, 0, 0, 0);

        const diff = target - now;

        if (diff <= 0) {
            this.hoursEl.textContent = '00';
            this.minusEl.textContent = '00';
            this.secondsEl.textContent = '00';
            return;
        }

        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minusEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
}
customElements.define("promotion-box", PromotionBox);
var elementsShipping = document.querySelectorAll(
  ".deliver-to-country-line, .selected-coutry,#box-shipping,.disclosure__toggle--country"
);
elementsShipping.forEach(function (element) {
  element.addEventListener("click", function () {
    var popupShippingCountryElement = document.querySelector(
      ".popup-shipping-country"
    ),
      currency = getCookieByProduct("currency") || "USD",
      selectCurrency = document.querySelector(
        "#currencies-country .currencies-country"
      );
    selectCurrency && (selectCurrency.value = currency);
    var bgCountryElement = document.querySelector(".bg-country");
    popupShippingCountryElement.classList.toggle("hidden"),
      bgCountryElement.classList.toggle("hidden");
  });
});
var closedShipping = document.querySelectorAll(
  ".bg-country,.img-closed-popup-shipping"
);
closedShipping.forEach(function (element) {
  element.addEventListener("click", function () {
    var popupShippingCountryElement = document.querySelector(
      ".popup-shipping-country"
    ),
      bgCountryElement = document.querySelector(".bg-country");
    popupShippingCountryElement.classList.toggle("hidden"),
      bgCountryElement.classList.toggle("hidden");
  });
}),
  $(document).ready(function () {
    var currency = $(".currencies").val();
    currency === "USD"
      ? ($("#pp-pay-later-message-desktop").show(),
        $("#pp-pay-later-message").show())
      : ($("#pp-pay-later-message-desktop").hide(),
        $("#pp-pay-later-message").hide());
  }),
  $("body").on("change", ".currencies", function (e) {
    var currency = $(this).val();
    currency === "USD"
      ? ($("#pp-pay-later-message-desktop").show(),
        $("#pp-pay-later-message").show())
      : ($("#pp-pay-later-message-desktop").hide(),
        $("#pp-pay-later-message").hide());
  });
function generateFileAuth(apiKey) {
  if (!engraver) {
    alert("not support");
    return;
  }
  if (!engraver.currentProduct) {
    alert("no select currentProduct");
    return;
  }
  var texts = engraver.textObjects.map(function (t) {
    return {
      id: t.id,
      uuid: t.uuid,
      textValue: t.clText || t.getText(),
      colorOption: t.selectedColorId || 1,
      colorHex: t.selectedColorHex,
      fontId: t.selectedFont || 1,
    };
  }),
    circularsText = engraver.circularTextObjects.map(function (t) {
      return {
        id: t.id,
        uuid: t.uuid,
        textValue: t.clText || t.text,
        colorOption: t.selectedColorId || 1,
        colorHex: t.selectedColorHex,
        fontId: t.selectedFont || 1,
      };
    }),
    vectorObjects = engraver.vectorEPSObjects
      .filter(function (t) {
        return !t.allowUserUpload;
      })
      .map(function (t) {
        return {
          id: t.id,
          uuid: t.uuid,
          position: t.selectedVectorIndex,
          realPosition:
            t.vectorLibraryId || t.hasLibrary
              ? t.selectedVectorIndex
              : t.selectedVectorIndex + 1,
          colorPosition: t.lastColorPosition,
          colorHex: t.lastColorHex,
        };
      }),
    imagesParameters = engraver.imageHolderObjects.map(function (t) {
      var e = "";
      return (
        (e =
          t.hasStaticImage || t.dynamicImagesPath
            ? t.id + "-serverStoredImage"
            : t.imageName),
        {
          id: t.id,
          isStaticImage: !!t.hasStaticImage,
          fileName: e,
          uuid: t.uuid,
          position: t.selectedImageIndex,
          colorPosition: t.lastColorPosition,
          colorHex: t.lastColorHex,
          offsetX: t.getEditModeImageParameters().offsetX,
          offsetY: t.getEditModeImageParameters().offsetY,
          previewOriginalElementWidth: t.originalElement.width,
          previewOriginalElementHeight: t.originalElement.height,
          angle: t.getEditModeImageParameters().angle,
          maskScaleX: t.getEditModeImageParameters().scaleX,
          maskScaleY: t.getEditModeImageParameters().scaleY,
          threshold: t.threshold,
        }
      );
    }),
    vectorsParameters = engraver.vectorEPSObjects
      .filter(function (t) {
        return t.allowUserUpload;
      })
      .map(function (t) {
        var e = t.getEditModeParameters();
        return {
          id: t.id,
          fileName: t.vectorName,
          uuid: t.uuid,
          offsetX: e.offsetX,
          offsetY: e.offsetY,
          scaleX: e.scaleX,
          scaleY: e.scaleY,
          angle: e.angle,
        };
      }),
    payload = {
      texts,
      circularTexts: circularsText,
      vectorPlaceholders: vectorObjects,
      id: engraver.currentProduct.id,
      fileName: "sadasdas-.png",
      sessionId: engraver.getSessionId(),
      clientVersion: "1.0.0",
      imagesParameters,
      vectorsParameters,
    };
  return $.ajax({
    type: "POST",
    url: "https://design-prod.medzt.com/api/productfile/generate-auth",
    crossDomain: !0,
    data: payload,
    dataType: "json",
    headers: {
      authorization: apiKey,
    },
    error: function (request, status, error) {
      const responseEror = JSON.parse(request.responseText);
      responseEror && responseEror.message && alert(responseEror.message);
    },
  });
}
function actionTabs(className) {
  const divElement = $(`.${className}`);
  let curTab = 0;
  const collectionTab = divElement
    .children(".sixteen.columns")
    .children(".box-action-tabs")
    .children(".tab-collection"),
    boxActionTab = divElement
      .children(".sixteen.columns")
      .children(".box-action-tabs");
  collectionTab.width() >= boxActionTab.width() &&
    (collectionTab.toggleClass("flex"),
      boxActionTab.children(".pf_arrow-next").toggleClass("show-action"));
  const tabMenu = divElement
    .children(".sixteen.columns")
    .children(".box-action-tabs")
    .children(".tab-collection")
    .children(".tab-collection-title"),
    tabBar = divElement
      .children(".sixteen.columns")
      .children(".box-action-tabs")
      .children(".tab-collection");
  let maxTabOffset = divElement.children(".sixteen.columns").width();
  divElement
    .children(".sixteen.columns")
    .children(".box-action-tabs")
    .children(".pf_arrow-next")
    .on("click", function () {
      curTab < tabMenu.length - 1 && (autoScroll(1), tabMenu[++curTab].click());
    }),
    divElement
      .children(".sixteen.columns")
      .children(".box-action-tabs")
      .children(".pf_arrow-prev")
      .on("click", function () {
        curTab > 0 && (autoScroll(0), tabMenu[--curTab].click());
      });
  function autoScroll(direction) {
    let offset = 0,
      posTab = 0;
    direction > 0
      ? ((posTab =
        tabMenu[curTab + 1].offsetLeft + tabMenu[curTab + 1].clientWidth),
        posTab >= maxTabOffset &&
        (tabBar.animate(
          {
            scrollLeft:
              tabMenu[curTab + 1].offsetLeft - tabBar.width() * 0.03,
          },
          500
        ),
          (maxTabOffset += offset),
          boxActionTab.children(".pf_arrow-prev").addClass("show-action")),
        posTab < maxTabOffset &&
        boxActionTab.children(".pf_arrow-prev").removeClass("show-action"),
        curTab + 1 == tabMenu.length - 1 &&
        boxActionTab.children(".pf_arrow-next").removeClass("show-action"))
      : (tabMenu[curTab - 1].offsetLeft == 0 &&
        boxActionTab.children(".pf_arrow-prev").removeClass("show-action"),
        tabBar.animate(
          {
            scrollLeft: tabMenu[curTab - 1].offsetLeft - tabBar.width() * 0.03,
          },
          500
        ),
        boxActionTab.children(".pf_arrow-next").addClass("show-action"));
  }
  tabMenu.on("click", function () {
    $(this)
      .parent(".tab-collection")
      .children(".tab-collection-title")
      .removeClass("active"),
      $(this).addClass("active"),
      (curTab = Array.from(tabMenu).indexOf(this));
    const slugCollection = $(this).attr("slug-col"),
      parentCollection = $(this).parent().parent().parent(".sixteen.columns");
    parentCollection
      .children(".featured-collection-product")
      .removeClass("active"),
      parentCollection
        .children(`.featured-collection-product[slug-col=${slugCollection}]`)
        .addClass("active"),
      parentCollection.children(".collection-shop-all").removeClass("active"),
      parentCollection
        .children(`.collection-shop-all[slug-col=${slugCollection}]`)
        .addClass("active");
  });
}
function getCookieByProduct(key) {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? keyValue[2] : null;
}
const addMaximumScaleToMetaViewport = () => {
  const el = document.querySelector("meta[name=viewport]");
  if (el !== null) {
    let content = el.getAttribute("content"),
      re = /maximum\-scale=[0-9\.]+/g;
    re.test(content)
      ? (content = content.replace(re, "maximum-scale=1.0"))
      : (content = [content, "maximum-scale=1.0"].join(", ")),
      el.setAttribute("content", content);
  }
},
  disableIosTextFieldZoom = addMaximumScaleToMetaViewport,
  checkIsIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
checkIsIOS() && disableIosTextFieldZoom(),
  window.addEventListener("pageshow", function (event) {
    event.persisted &&
      $("#customily-cart-btn-preview").removeClass("ld-custom");
  }),
  document.addEventListener("DOMContentLoaded", function () {
    fetchCartData(),
      document.addEventListener("pageshow", function () {
        fetchCartData();
      });
    function fetchCartData() {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
          const cartCount = $("#header-cart-count-bubble");
          cartCount[0] && (cartCount[0].innerHTML = data.item_count);
        });
    }
    window.addEventListener("scroll", function() {
      var scroll = window.pageYOffset || document.documentElement.scrollTop;
      var topScrollButton = document.querySelector("#top_scroll_button");
    
      if (scroll >= 1000) {
        topScrollButton.style.display = "block";
      } else {
        topScrollButton.style.display = "none";
      }
      topScrollButton.addEventListener("click",function(){
          scrollToTop(1000);
      })
    });
    function scrollToTop(duration) {
      var start = window.pageYOffset || document.documentElement.scrollTop;
      var startTime = null;
    
      function animation(currentTime) {
        if (startTime === null) {
          startTime = currentTime;
        }
    
        var elapsedTime = currentTime - startTime;
        var ease = easeInOutCubic(elapsedTime, start, -start, duration);
        window.scrollTo(0, ease);
    
        if (elapsedTime < duration) {
          requestAnimationFrame(animation);
        }
      }
    
      function easeInOutCubic(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t + b;
        t -= 2;
        return c / 2 * (t * t * t + 2) + b;
      }
    
      requestAnimationFrame(animation);
    }
  }),
  $(document).ready(function () {
    $(".footer__content-top .footer-block__details-content a.sub-link").on(
      "click",
      function (event) {
        event.preventDefault(), $(this).toggleClass("active");
      }
    );
  });
//# sourceMappingURL=/cdn/shop/t/30/assets/global.js.map?v=32779298822808799641724735960

function toogleModalFindOrder() {
  document.querySelector(".popup-find-my-order").classList.toggle("active");
  document.querySelector(".bg-find-order").classList.toggle("active");
}
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains('product')) {
    var num = 0;
    var myInterval = setInterval(() => {
      if (document.getElementById('mademine-node') != null || num == 50) {
        clearInterval(myInterval);
        if (document.getElementById('mademine-node') != null) {
          var preview = document.createElement("div");
          preview.classList = "btn-preview hidden-xl";
          preview.innerHTML = `<a id="btn-preview" href="#teeFormActions" class="button customily-preview-button">Preview Your Personalization</a>`;
          document.querySelector(".product__info-container").appendChild(preview);
          document.getElementById("btn-preview").addEventListener("click", (e) => {
            e.preventDefault();
            // var scrollDiv = document.getElementById("teeFormActions").offsetTop;
            // window.scrollTo({ top: scrollDiv, behavior: "smooth" });
            if(document.querySelector('#mademine-node .__button')){
              document.querySelector('#mademine-node .__button').click()
            }
            if(document.querySelector('#mademine-node [class*="sunzi__button"]')){
              document.querySelector('#mademine-node [class*="sunzi__button"]').click()
            }
          });
        }
      }
      num += 1;
    }, 100)
  }
  const track = () => {
    var findOrderNumber = document.createElement('span');
    findOrderNumber.classList.add('find-order-number');
    findOrderNumber.innerText = 'I do not know my order number';
    if(document.querySelector(".tm_tracking_form")){
      document.querySelector(
        ".tm_tracking_form"
      ).append(findOrderNumber);
    }
    if(document.querySelector(".pp_tracking_form_in")){
      document.querySelector(
        ".pp_tracking_form_in"
      ).after(document.querySelector('.tracking-faq'));
      document.querySelector(
        ".pp_tracking_form_in"
      ).append(findOrderNumber);
    }
    var faq = document.querySelector(".tracking-faq");
    if (document.querySelector(".tm_tracking_form") != null) {
      document.querySelector(".tm_tracking_form").after(faq);
    }
    if (document.querySelector(".bg-find-order")) {
      document
        .querySelector(".bg-find-order")
        .addEventListener("click", function () {
          toogleModalFindOrder();
        });
    }
    if (document.querySelector(".find-order-number")) {
      document
        .querySelector(".find-order-number")
        .addEventListener("click", function () {
          toogleModalFindOrder();
        });
    }

    if (document.querySelector(".btn-tracking-tutorial")) {
      document
        .querySelector(".btn-tracking-tutorial")
        .addEventListener("click", function () {
          toogleModalFindOrder();
        });
    }
    setInterval(() => {
      document.querySelectorAll('.tm_tracking_result_parent.tm_timeline li').forEach(item => {
        if(item.querySelector('.font-grey-cascade')){
          if(item.querySelector('.font-grey-cascade').innerText.includes('China') || item.querySelector('.font-grey-cascade').innerText.includes('CN') || item.querySelector('.font-grey-cascade').innerText.includes('Mainland')){
            item.querySelector('.font-grey-cascade').innerText = item.querySelector('.font-grey-cascade').innerText.replace(', Mainland China','')
            item.querySelector('.font-grey-cascade').innerText = item.querySelector('.font-grey-cascade').innerText.replace(', CN','')
            item.querySelector('.font-grey-cascade').innerText = item.querySelector('.font-grey-cascade').innerText.replace('China','')
            item.querySelector('.font-grey-cascade').innerText = item.querySelector('.font-grey-cascade').innerText.replace('CN','')
           item.querySelector('.font-grey-cascade').innerText = item.querySelector('.font-grey-cascade').innerText .replace('Mainland','')
          }
        }
      })
    },1000)
  };
  if (window.location.pathname == "/apps/trackingmore" || window.location.pathname == "/apps/parcelpanel") {
    track();
    fetch("/pages/trackingmore")
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc3 = parser.parseFromString(html, "text/html");
        var featured_collection = document.createElement('section');
        featured_collection.setAttribute('id', doc3.querySelector('section.featured-collection').getAttribute('id'))
        featured_collection.classList = 'shopify-section section featured-collection';
        featured_collection.innerHTML = doc3.querySelector('section.featured-collection').innerHTML;
        document.getElementById('tm_tracking_frame').after(featured_collection)
      });
  }

  $(document).ready(function () {
    $(".faq-item-title").click(function () {
      $(this).parent().children(".faq-item-panel").slideToggle();
      $(this).toggleClass("active");
    });
    // $(".product-rating").click(function () {
    //   $("#reviews").get(0).scrollIntoView({ behavior: 'smooth' });
    // });

  });
});
